/* global gdAlertify */
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from "../config/axiosConfig"; // Asegúrate de tener tu configuración de axios
import BuscarUsuario from "./components/BuscarUsuario";
import Calendario from "./components/Calendario";
import { formatDateTime, formatMonthDate, formatDate } from "../utils/utils";
import { isNullOrUndef } from "chart.js/helpers";
import MonthInput from "./components/MonthInput";

const tiposVisitaPonderacion = [
    { key: "telefonicas", label: "Telefónica", peso: "0,5" },
    { key: "presenciales", label: "Presencial", peso: "1" },
    { key: "lejanas", label: "Lejana", peso: "3" },
    { key: "muyLejanas", label: "Muy lejana", peso: "5" },
    { key: "enfermeria", label: "Ingreso Enfermería", peso: "1" },
];

const getIndicadorNumber = (indicadores, keys) => {
    const key = keys.find((item) => indicadores?.[item] !== undefined && indicadores?.[item] !== null);
    return Number(indicadores?.[key] || 0);
};

const BitacoraCoordinacion = () => {
    const [usuarioInfo, setusuarioInfo] = useState(null);
    const [visitas, setVisitas] = useState([]);
    const [fechasVisitas, setFechasVisitas] = useState([]);
    const [filtradasVisitas, setFiltradasVisitas] = useState([]);
    const [detalleVisita, setDetalleVisita] = useState(null);
    const [startMonth, setStartMonth] = useState(new Date().toISOString().slice(0, 7));
    const handleSeleccionaPaciente = async (paciente) => {
        setusuarioInfo(paciente);
    };
    const [selectedDate, setSelectedDate] = useState(null);

    const handleDateSelect = (date) => {
        setSelectedDate(date.format('YYYY-MM-DD'));
        let visitasFiltradas = visitas.visitas.filter(visita => visita.fecha_visita === date.format('YYYY-MM-DD'));
        setFiltradasVisitas(visitasFiltradas);
    };

    const handleMonthChange = (e) => {
        setStartMonth(e.target.value); // Cambiar el mes seleccionado
    };

    const verVisita = (visitaID) => {
        let visitaDetalle = visitas.visitas.filter(visita => visita.visitaID === visitaID && visita.tipo_visita == 1)[0];
        setDetalleVisita(visitaDetalle);
    }
    const verEnfermeria = (visitaID) => {
        let visitaDetalle = visitas.visitas.filter(visita => visita.visitaID === visitaID && visita.tipo_visita == 2)[0];
        setDetalleVisita(visitaDetalle);
    }

    const renderDetalle = (titulo, valor) => {
        // if (valor) {
        return (
            <div key={titulo} className="mb-3 col-6">
                <h5>{titulo}</h5>
                <p>{valor}</p>
            </div>
        );
        // }
        // return null; // Si el valor es vacío o nulo, no lo renderiza
    };

    const navigate = useNavigate();
    const editarVisita = (visitaID, tipo) => {
        gdAlertify.confirm({
            title: 'Editar visita',
            message: '¿Está seguro de que desea editar esta visita?',
            onConfirm: async () => {
                if (tipo == 1) {
                    navigate('/form-visita/' + visitaID);
                } else {
                    navigate('/form-ingreso-enfermeria/' + visitaID);
                }
            },
            onCancel: () => {
                gdAlertify.notify('Acción cancelada', 'info');
            }
        });
    };

    const eliminarVisita = (visitaID, tipo) => {
        gdAlertify.confirm({
            title: 'Eliminar visita',
            message: '¿Está seguro de que desea eliminar esta visita?',
            onConfirm: async () => {
                try {
                    const response = await axiosInstance.post('paciente/eliminar-visita', { visitaId: visitaID, tipo: tipo });

                    if (!response.data.error) {
                        gdAlertify.notify('Visita eliminada correctamente', 'success');
                        setDetalleVisita(null);
                        buscar();
                    } else {
                        gdAlertify.notify(response.data.message || 'Error al eliminar la visita', 'error');
                    }
                } catch (error) {
                    gdAlertify.notify('Error al eliminar la visita', 'error');
                }
            },
            onCancel: () => {
                gdAlertify.notify('Acción cancelada', 'info');
            }
        });
    };

    const authToken = localStorage.getItem('authToken');

    const decodeJWT = (token) => {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            return JSON.parse(jsonPayload);
        } catch (error) {
            return null;
        }
    };
    const decodedToken = authToken ? decodeJWT(authToken) : null;
    const usuarioActualID = decodedToken.id

    const formatearFechaConMesTexto = (fechaISO) => {
        const meses = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];
        const [anio, mes, dia] = fechaISO.split("-");
        return `${parseInt(dia)}/${meses[parseInt(mes) - 1]}/${anio}`;
    };

    const indicadores = visitas.indicadores || null;
    const kpisBitacora = indicadores ? [
        {
            label: "Total ponderado",
            value: indicadores.total_visitas,
            icon: "bi-calculator",
            variant: "primary",
        },
        {
            label: "Presenciales",
            value: indicadores.visitas_presenciales,
            icon: "bi-person-check",
            variant: "success",
        },
        {
            label: "Lejanas",
            value: getIndicadorNumber(indicadores, ["visitas_lejanas", "visitas_presenciales_fuera"]),
            icon: "bi-geo-alt",
            variant: "warning",
        },
        {
            label: "Muy lejanas",
            value: getIndicadorNumber(indicadores, ["visitas_muy_lejanas", "visitas_presenciales_muy_fuera"]),
            icon: "bi-signpost-split",
            variant: "danger",
        },
        {
            label: "Telefónicas",
            value: indicadores.visitas_telefonicas,
            icon: "bi-telephone",
            variant: "info",
        },
        {
            label: "Ing. Enfermería",
            value: indicadores.ingreso_enfermeria,
            icon: "bi-clipboard2-pulse",
            variant: "secondary",
        },
    ] : [];

    const buscar = async () => {
        if (isNullOrUndef(usuarioInfo)) {
            gdAlertify.notify('Seleccione Usuario', 'error');
            return;
        }
        gdAlertify.showLoader()
        try {
            const solicitudes = await axiosInstance.post("/usuario/visitas",
                {   usuarioID: usuarioInfo.id,
                    periodo: startMonth
                 }
            );
            let fechasVisitas = [];
            console.log(solicitudes)
            setVisitas(solicitudes.data.data);
            if (solicitudes.data.data.visitas && solicitudes.data.data.visitas.length > 0) {
                fechasVisitas = solicitudes.data.data.visitas.map(visita => visita.fecha_visita);
            } else {
                setFiltradasVisitas([]);
                setDetalleVisita(null);
            }
            setFechasVisitas(fechasVisitas);
            gdAlertify.hideLoader()
        } catch (error) {
            gdAlertify.hideLoader()
            console.error("Error al obtener los datos: ", error);
        }
    };

    return (
        <div className="container mt-5">
            <div className="card p-4">
                <h3 className="mb-4">Bitacora Enfermero/a</h3>
                <div className="mb-3">
                    <div className="row">
                        <div className="border p-4 mb-4 col-12">
                            <div className="row g-3 d-flex justify-content-between">
                                <div className="col-md-6">
                                    <BuscarUsuario onSelect={handleSeleccionaPaciente} onClear={handleSeleccionaPaciente} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label fw-bold">Mes</label>
                                    <MonthInput
                                        className="form-control"
                                        placeholder="Mes de inicio"
                                        value={startMonth}
                                        onChange={handleMonthChange} // Cambiar mes
                                    />
                                </div>
                                <div className="col-md-12 d-flex justify-content-center">
                                    <button className="btn btn-primary" onClick={buscar}>
                                        Buscar
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="border p-4 mb-4 col-5">
                            <div className="row">
                                <div className="col-md-8">
                                    <label className="form-label fw-bold">Enfermero</label>
                                    <p id="nombrePaciente" className="form-control-plaintext">
                                        {usuarioInfo
                                            ? `${usuarioInfo.nombre} ${usuarioInfo.apellido}`
                                            : ""}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="border p-3 mb-4 col-7">
                            {indicadores ? (
                                <>
                                    <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
                                        <div>
                                            <div className="text-uppercase text-muted fw-semibold small">Resumen del mes</div>
                                            <div className="text-muted small">El total usa la ponderación por tipo de visita.</div>
                                        </div>
                                        <span className="badge bg-primary-subtle text-primary border border-primary-subtle">
                                            Total {indicadores.total_visitas}
                                        </span>
                                    </div>
                                    <div className="row g-2">
                                        {kpisBitacora.map((kpi) => (
                                            <div className="col-6 col-xl-4" key={kpi.label}>
                                                <div className="d-flex align-items-center gap-2 rounded border bg-light px-2 py-2 h-100">
                                                    <span className={`text-${kpi.variant}`}>
                                                        <i className={`bi ${kpi.icon}`}></i>
                                                    </span>
                                                    <div className="min-w-0">
                                                        <div className="small text-muted text-truncate">{kpi.label}</div>
                                                        <div className="fs-5 fw-bold lh-1">{kpi.value || 0}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="d-flex flex-wrap gap-1 mt-2">
                                        {tiposVisitaPonderacion.map((tipo) => (
                                            <span className="badge rounded-pill bg-white text-dark border" key={tipo.key}>
                                                {tipo.label} x {tipo.peso}
                                            </span>
                                        ))}
                                    </div>
                                </>
                            ) : ''}
                        </div>
                        <div className="border p-4 mb-4 col-12">
                            <Calendario
                                validDates={fechasVisitas}
                                onDateSelect={handleDateSelect}
                                displayDate={`${startMonth}-01`}
                            />
                        </div>
                        <div className="border p-4 mb-4 col-2">
                            <h4>Visitas</h4>
                            {filtradasVisitas.map((visita, index) => (
                                <button
                                    key={visita.visitaID + '-' + visita.tipo_visita}
                                    className={`btn ${visita.tipo_visita == 1 ? "btn-primary" : "btn-success"} mb-2 w-100 text-start`}
                                    onClick={() => {
                                        if (visita.tipo_visita == 1) {
                                            verVisita(visita.visitaID);
                                        } else if (visita.tipo_visita == 2) {
                                            verEnfermeria(visita.visitaID);
                                        }
                                    }}
                                >
                                    <div>{(visita.nombre_paciente || visita.nombres || '') + ' ' + (visita.apellido_paciente || visita.apellidoPaterno || '')}</div>
                                    <small>{visita.tipo_visita == 1 ? "Visita" : "Enfermería"} {index + 1}</small>
                                </button>
                            ))}
                        </div>
                        <div className="border p-4 mb-4 col-10">
                            <div className="d-flex align-items-center mb-3">
                                <h4>Detalle</h4>
                                {detalleVisita && (detalleVisita.usuarioID == usuarioActualID || detalleVisita.usuario_id == usuarioActualID) && (
                                    <div className="d-flex">
                                        <button
                                            className="btn btn-danger justify-content-end ms-auto"
                                            onClick={() => eliminarVisita(detalleVisita.visitaID, detalleVisita.tipo_visita)}
                                        >
                                            Eliminar {detalleVisita.tipo_visita === 1 ? "Visita" : "Enfermería"}
                                        </button>

                                        <button
                                            className="btn btn-success justify-content-end ms-auto"
                                            onClick={() => editarVisita(detalleVisita.visitaID, detalleVisita.tipo_visita)}
                                        >
                                            Editar {detalleVisita.tipo_visita === 1 ? "Visita" : "Enfermería"}
                                        </button>
                                    </div>
                                )}
                            </div>
                            {detalleVisita ? (
                                <div className="row">
                                    {detalleVisita.tipo_visita === 1 ? (
                                        <>
                                            {renderDetalle('Enfermero/a Visita', detalleVisita.usuario_visita)}
                                            {renderDetalle('Nombre Paciente', detalleVisita.nombres + ' ' + detalleVisita.apellidoPaterno)}
                                            {renderDetalle('Fecha de la Visita', formatDate(detalleVisita.fecha_visita))}
                                            {renderDetalle('Mes de la Visita', formatMonthDate(detalleVisita.fecha_visita))}
                                            {renderDetalle('Tipo de Visita', detalleVisita.tipo_visita === 1 ? 'Presencial' : 'Telefónico')}
                                            {renderDetalle('Diagnóstico', detalleVisita.diagnostico)}
                                            {renderDetalle('Estado de Salud', detalleVisita.estado_salud)}
                                            {renderDetalle('Estado Cognitivo', detalleVisita.estado_cognitivo)}
                                            {renderDetalle('Lenguaje', detalleVisita.habla)}
                                            {renderDetalle('Movilidad', detalleVisita.movimiento)}
                                            {renderDetalle('Antecedentes Médicos', detalleVisita.antecedentes_medicos)}
                                            {renderDetalle('Evolución', detalleVisita.examen_fisico)}
                                            {renderDetalle('Medicamentos y Horarios', detalleVisita.medicamento_horarios)}
                                            {renderDetalle('Rutinas y/o actividades del paciente', detalleVisita.rutina)}
                                            {renderDetalle('Plan de Atención', detalleVisita.plan_atencion)}
                                            {renderDetalle('Observación paciente', detalleVisita.observacion)}
                                            {detalleVisita.nombre_auxiliar_visita && renderDetalle('Auxiliar', detalleVisita.nombre_auxiliar_visita)}
                                            {detalleVisita.observacion_auxiliar && renderDetalle('Observación Auxiliar', detalleVisita.observacion_auxiliar)}
                                        </>
                                    ) : (
                                        <>
                                            {renderDetalle('Enfermero/a Visita', detalleVisita.nombre + ' ' + detalleVisita.apellido)}
                                            {renderDetalle('Nombre Paciente', detalleVisita.nombre_paciente + ' ' + (detalleVisita.apellido_paciente || ''))}
                                            {renderDetalle('Fecha de Registro', formatDateTime(detalleVisita.fechaRegistro))}
                                            {renderDetalle('Mes de Registro', formatMonthDate(detalleVisita.fechaRegistro))}
                                            {renderDetalle('Estado de Cama', detalleVisita.estadoCama)}
                                            {renderDetalle('Estado de Casa', detalleVisita.estadoCasa)}
                                            {renderDetalle('Estado Cognitivo', detalleVisita.estadoCognitivo)}
                                            {renderDetalle('Estado de Salud', detalleVisita.estadoSalud)}
                                            {renderDetalle('Estado de Habitación', detalleVisita.estadoHabitacion)}
                                            {renderDetalle('Evaluación Domicilio', detalleVisita.evaluacionDomicilio)}
                                            {renderDetalle('Evolución', detalleVisita.examenFisico)}
                                            {renderDetalle('Asistencia Adicional', detalleVisita.asistenciaAdicional)}
                                            {renderDetalle('Lenguaje', detalleVisita.capacidadHablar)}
                                            {renderDetalle('Movilidad', detalleVisita.capacidadMoverse)}
                                            {renderDetalle('Medicamentos', detalleVisita.medicamentos)}
                                            {renderDetalle('Necesidades Especiales', detalleVisita.necesidadesEspeciales)}
                                            {renderDetalle('Plan de Atención', detalleVisita.planAtencion)}
                                            {renderDetalle('Riesgos', detalleVisita.riesgos)}
                                            {renderDetalle('Rutinas', detalleVisita.rutinas)}
                                        </>
                                    )}

                                </div>
                            ) : null}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default BitacoraCoordinacion;
